import Api from '../api'
const ENTITY_ENDPOINT = 'entity/formats';

export default {
    state: {
        records: []
    },

    getters: {
        getRecords: state => state.records
    },

    mutations: {
        setRecords: (state, records) => state.records = records,
        addRecords: (state, records) => state.records.push(...records),
 
    },

    actions: {
        async fetchFormatRecords({commit}, format_id){
            const response = await Api.get(`${ENTITY_ENDPOINT}/${format_id}/records`);
            commit('setRecords', response.body.data)
        },
        async storeExcelRecords({commit}, payload){
            const response = await Api.post(`${ENTITY_ENDPOINT}/${payload.format_id}/records`, payload.data);
            commit('addRecords', response.body.data)
        },
        async updateRecordImages({commit}, payload){
            const response = await Api.post(`${ENTITY_ENDPOINT}/${payload.format_id}/records`, payload.data);
            window.location.reload();
        }
    }
}